// Arabic labels for teacher specialty tags. Specialties are stored on the
// backend as free-form comma-separated English strings (Hudan Teacher
// Profile.specialties), so translation has to happen at render time.
// Keys are lowercased; lookup falls back to the raw value for unknown tags.
const SPECIALTY_AR: Record<string, string> = {
  'hifz': 'الحفظ',
  'tajweed': 'التجويد',
  'tafseer': 'التفسير',
  "qira'at": 'القراءات',
  'qiraat': 'القراءات',
  'recitation': 'التلاوة',
  'tarteel': 'الترتيل',
  'sanad': 'السند',
  'quran': 'القرآن الكريم',
  'islamic studies': 'الدراسات الإسلامية',
  'quranic arabic': 'العربية القرآنية',
  'calligraphy': 'الخط العربي',
  'arabic': 'اللغة العربية',
  'arabic language': 'اللغة العربية',
  'conversational arabic': 'العربية للمحادثة',
  'nahw': 'النحو',
  'children': 'تعليم الأطفال',
  "children's education": 'تعليم الأطفال',
  "children's quran": 'قرآن الأطفال',
  "women's classes": 'دروس النساء',
  'new muslims': 'المسلمون الجدد',
  'beginners': 'المبتدئون',
  'nooraniyah': 'القاعدة النورانية',
  'nooraniyah method': 'القاعدة النورانية',
};

export function specialtyLabel(specialty: string, isRTL: boolean): string {
  if (!isRTL) return specialty;
  return SPECIALTY_AR[specialty.trim().toLowerCase()] ?? specialty;
}
